<template>
  <div class="before_optin">
    <div class="desc mb-8">
      <p class="text-center" v-html="$t('promotion.fundsGrowthPromotion.description1')"></p>
    </div>
    <div class="select_acc">
      <div class="mb-10 leading-8 sm:leading-6 text-center">
        {{ $t('promotion.fundsGrowthPromotion.description2') }}
      </div>
      <el-form :model="form" ref="form" :rules="formRules">
        <SelectForm
          v-model="form.selectedRedeemableAccount"
          name="selectedRedeemableAccount"
          :label="$t('promotion.fundsGrowthPromotion.accountNumber')"
          :placeholder="$t('promotion.fundsGrowthPromotion.selectAccount')"
          class="showPlaceholder"
          multiple
        >
          <el-option
            v-for="item in redeemableAccounts"
            :key="item.mt4Account"
            :label="item.mt4Account"
            :value="item.mt4Account"
          >
          </el-option>
        </SelectForm>

        <el-form-item prop="isAgreeTnc" class="tnc">
          <el-checkbox v-model="form.isAgreeTnc" name="isAgreeTnc"></el-checkbox>
          <i18n path="promotion.fundsGrowthPromotion.tncConfirm" tag="p">
            <template v-slot:tnc>
              <a :href="tncLink" target="_blank">{{ $t('promotion.fundsGrowthPromotion.tnc') }}</a>
            </template>
          </i18n>
        </el-form-item>
      </el-form>

      <div class="flex justify-center">
        <el-button
          class="mt-6 blue_button fgp_blue_button disabled:border-[#cdcfd3]! disabled:bg-transparent!"
          @click="handleOptIn"
        >
          {{ $t('promotion.fundsGrowthPromotion.button.optIn') }}
        </el-button>
      </div>
    </div>

    <CongratulationModal
      :congratulationModalVisible.sync="congratulationModalVisible"
      :tncLink="tncLink"
    ></CongratulationModal>
  </div>
</template>

<script>
import { apiOptInWithAccounts } from '@/resource';
import { checkAgreedTNC, validateRequireArray } from '@/util/validation';
import CongratulationModal from './CongratulationModal.vue';

export default {
  name: 'BeforeOptIn',
  components: {
    CongratulationModal
  },
  props: {
    campaignId: Number,
    optIn: Boolean,
    redeemableAccounts: Array,
    tncLink: String
  },
  data() {
    return {
      form: {
        selectedRedeemableAccount: [],
        isAgreeTnc: false
      },
      formRules: {
        selectedRedeemableAccount: [
          {
            required: true,
            validator: validateRequireArray,
            trigger: 'change'
          }
        ],
        isAgreeTnc: [{ validator: checkAgreedTNC, trigger: 'change' }]
      },
      congratulationModalVisible: false
    };
  },
  methods: {
    handleOptIn() {
      this.$refs.form?.validate(valid => {
        if (valid) {
          const reqBody = {
            campaignId: this.campaignId,
            optIn: true,
            accountMt4DtoList: this.form.selectedRedeemableAccount.map(acc => {
              return {
                mt4Account: acc,
                datasourceId: this.redeemableAccounts.find(i => i.mt4Account === acc).datasourceId
              };
            })
          };

          apiOptInWithAccounts(reqBody).then(resp => {
            if (resp.data.data) {
              this.congratulationModalVisible = true;
            } else {
              this.$message({
                message: this.$t('common.field.failed'),
                type: 'error',
                duration: 5000
              });
            }
          });
        } else return false;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/pages/fundsGrowthPromotion.scss';
</style>
